//@ts-check
import React from 'react';
import { Formatter } from 'ecrion-components';
var SYNCLOG_DATA_TYPE = {
  data: {
    dataKey: 'syncLog',
    url: '/backend/crm/syncLog',
    idKeyProp: 'Id',
    by: 'Timestamp',
    sort: 'desc'
  },
  placeholders: {
    label: function label(data) {
      return data.Severity;
    },
    type: function type() {
      return 'syncLog';
    },
    icon: function icon() {
      return 'syncLog';
    }
  },
  columns: [{
    id: 'Severity',
    children: 'Severity',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      var spanClass = '',
          style = {
        marginRight: '3px',
        color: '#1666ab'
      };

      if (data.BackendLog.Severity === 'Error') {
        spanClass = 'ecricon-error';
        style['color'] = 'red';
      } else if (data.BackendLog.Severity === 'Warning') {
        spanClass = 'ecricon-warning';
      } else if (data.BackendLog.Severity === 'Information') {
        spanClass = 'ecricon-info';
      } else if (data.BackendLog.Severity === 'Diagnostic Trace') {
        spanClass = 'ecricon-diagnostic';
      }

      return React.createElement(React.Fragment, null, React.createElement("span", {
        className: spanClass,
        style: style
      }), React.createElement(Formatter.Text, {
        value: data.BackendLog.Severity,
        style: {
          display: 'inline'
        }
      }));
    },
    width: {
      xs: '15%'
    }
  }, {
    id: 'Timestamp',
    children: 'Timestamp',
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.DateTime, {
        variant: "short",
        type: "datetime",
        value: data.BackendLog.Timestamp
      });
    },
    serverSort: true,
    width: {
      xs: '15%'
    }
  }, {
    id: 'Message',
    children: 'Message',
    formatter: function formatter(_ref3) {
      var data = _ref3.data;
      return React.createElement(Formatter.Text, {
        style: {
          whiteSpace: 'normal'
        },
        value: data.BackendLog.Message
      });
    },
    width: {
      xs: '70%'
    }
  }]
};
export default SYNCLOG_DATA_TYPE;